var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupagrowfav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 93,
    viewBox: "0 0 115 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.224 60.152H23.264C23.264 69.624 30.944 73.976 60.128 73.976C84.32 73.976 91.616 71.288 91.616 64.248C91.616 56.824 86.496 55.544 57.44 54.136C18.4 52.344 2.912 46.2 2.912 26.104C2.912 6.392 23.008 0.119995 56.544 0.119995C90.336 0.119995 110.816 8.56799 110.816 30.712H87.776C87.776 20.856 77.92 18.424 53.984 18.424C31.328 18.424 25.952 20.6 25.952 27.256C25.952 34.168 31.328 35.448 57.44 36.984C92.768 38.904 114.656 40.824 114.656 63.48C114.656 87.416 92 92.28 58.848 92.28C22.112 92.28 0.224 86.008 0.224 60.152Z",
    fill: "#020202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupagrowfav);
export default __webpack_public_path__ + "static/media/supagrowfav.e877ae5d27b0d707043f0e07a6199943.svg";
export { ForwardRef as ReactComponent };